import MultiSelect from "@khanacademy/react-multi-select";
import { Button, Col, Drawer, Form, Input, Row, Space, Spin } from "antd";
import { Component } from "react";
import logger from '../../utils/logger.js';
import { GET, POST } from "../constants/request-type";
import { get_all_user, push, send_push, user } from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { openNotificationWithIcon } from "../functions/notification";
import "../styles/general.css";

const token = sessionStorage.getItem("auth_token");

class Send_push extends Component {
  state = {
    visible: false,
    data1: [],
    data2: [],
    tokens: [],
    classes: {
      text: "Utilisateur",
      value: "user"
    },
    message: this.props.row.message,
    title: "",
    load: false
  };

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    var list = [];
    const request_details_user = {
      type: GET,
      url: service_api,
      route: user + "/" + get_all_user,
      data: null,
      token: token
    };

    try {
      const response_user = await MakeRequestAsync(request_details_user);
      const decryptedValue = decryptSingleData(response_user.data.user);
      decryptedValue
        ?.filter((item) => {
          return item.pushToken !== null && item.pushToken !== "";
        })
        .map((data) =>
          list.push({
            label: data?.email,
            value: data?.pushToken
          })
        );
      this.setState({
        load: false,
        data1: list
      });
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ load: true });
    const { tokens, title, message } = this.state;
    const data = {
      tokens: [...tokens],
      title: title,
      body: message,
      img: this.props.row?.icon
    };
    if (data.tokens.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon("error", "Aucune selection de personne");
    }

    if (data.body.length < 5 || data.title.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Le message doit être d'au moins 5 charatères et le titre ne peut etre null"
      );
    }

    const request_detail = {
      type: POST,
      url: service_api,
      route: push + "/" + send_push,
      data,
      token: token
    };

    try {
      await MakeRequestAsync(request_detail);
      logger.log("Envoie terminé");
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon("error", `${err.response.data.message}`);
    }
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { title, message, data1, load } = this.state;
    return (
      <>
        <Button type="danger" onClick={this.showDrawer}>
          Envoyer
        </Button>
        <Drawer
          title="Send push notification"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Cancel
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Submit
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="title"
                  label="Title"
                  rules={[{ required: true, message: "Please enter title" }]}
                >
                  <Input
                    name="title"
                    placeholder="Please enter title"
                    onChange={this.handleChange}
                    value={title}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Message"
                  rules={[{ required: true, message: "Please enter message" }]}
                >
                  <Input.TextArea
                    name="message"
                    rows={4}
                    placeholder="Please enter message"
                    onChange={this.handleChange}
                    value={message}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16} style={{ marginTop: 30 }}>
              <Col span={24}>
                <MultiSelect
                  options={data1}
                  onSelectedChanged={(tokens) => this.setState({ tokens })}
                  selected={this.state.tokens}
                />
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Send_push;
